module.exports = __webpack_public_path__ + "img/msg-icon.df12327d.png";